import { SkillLevelScreen } from '@/screens/name-screen/SkillLevelScreen'

export default function () {
  return <SkillLevelScreen />
}
